import React from 'react'
import { urls } from '../consts/urls'
import { language } from '../types'
import { localize } from '../utils/language'

export type ButtonLocation =
  | 'header'
  | 'main_visual'
  | 'page_top'
  | 'page_middle'
  | 'page_bottom'
  | 'store_section'
  | 'footer'

type SourcePage = 'home' | 'menus' | 'branch' | 'other'

type Props = {
  lang: language
  buttonLocation: ButtonLocation
  className?: string
  variant?: 'primary' | 'light'
  storeName?: string
}

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

const labels = {
  JA: 'テイクアウト注文はこちら',
  EN: 'Order Takeout',
  ZH: '外带点餐',
  TW: '外帶點餐',
  KO: 'Takeout Order',
}

const baseClass = 'inline-flex min-h-[52px] w-full items-center justify-center rounded px-6 py-3 text-center text-base font-semibold tracking-wider transition duration-300 ease-in-out sm:w-auto sm:min-w-[240px] lg:text-lg'

const variantClass = {
  primary: 'bg-primary-500 text-white shadow-lg shadow-black/10 hover:bg-primary-600',
  light: 'border border-white bg-white/95 text-primary-500 shadow-lg shadow-black/20 hover:bg-primary-500 hover:text-white',
}

const sourcePageFromPath = (pathname: string): SourcePage => {
  const pathWithoutLocale = pathname.replace(/^\/(en|zh|tw|ko)(?=\/|$)/, '') || '/'

  if (pathWithoutLocale === '/') return 'home'
  if (pathWithoutLocale === '/menus' || pathWithoutLocale.startsWith('/menus/')) return 'menus'
  if (pathWithoutLocale === '/branch' || pathWithoutLocale.startsWith('/branch/')) return 'branch'

  return 'other'
}

export const trackTakeoutOrderClick = (
  buttonLocation: ButtonLocation,
  linkUrl: string,
  storeName?: string
) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return

  window.gtag('event', 'takeout_order_click', {
    source_page: sourcePageFromPath(window.location.pathname),
    button_location: buttonLocation,
    ...(storeName ? { store_name: storeName } : {}),
    link_url: linkUrl,
  })
}

const TakeoutOrderButton = ({
  lang,
  buttonLocation,
  className = '',
  variant = 'primary',
  storeName,
}: Props) => (
  <a
    href={urls.takeawayOrder}
    target='_blank'
    rel='noopener noreferrer'
    onClick={() => trackTakeoutOrderClick(buttonLocation, urls.takeawayOrder, storeName)}
    className={`${baseClass} ${variantClass[variant]} ${className}`}
  >
    {localize(labels, lang)}
  </a>
)

export default TakeoutOrderButton
